import { render, staticRenderFns } from "./pin.vue?vue&type=template&id=158d34c5&scoped=true&"
import script from "./pin.vue?vue&type=script&lang=js&"
export * from "./pin.vue?vue&type=script&lang=js&"
import style0 from "./pin.vue?vue&type=style&index=0&id=158d34c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d34c5",
  null
  
)

export default component.exports